import "core-js/modules/es.function.name.js";
import axios from "axios";
import { request } from "@/utils/request";
export default {
  data: function data() {
    return {
      // platform: this.$store.state.design.platform,
      platform: localStorage.platform,
      previews: [{
        name: 'pc',
        link: process.env.VUE_APP_API_PC_PREVIEW,
        icon: 'li-icon-pc',
        class: 'pc-frame'
      }, {
        name: 'm',
        link: process.env.VUE_APP_API_APP_PREVIEW,
        icon: 'li-icon-m',
        class: 'm-frame'
      }]
    };
  },
  mounted: function mounted() {},
  methods: {
    handlePlatformClick: function handlePlatformClick(item) {
      this.platform = item.name;
    }
  }
};